function flattenGroups(groupedItems, orderedTypes) {
  return orderedTypes
    .reduce((all, id) => {
      return all.concat(groupedItems[id] || []);
    }, [])
    .concat(groupedItems.untyped || []);
}

export default flattenGroups;
